import { CheckIcon, PlusIcon } from '@heroicons/react/outline';
import { FC, useState } from 'react';
import {
  CuratedProviderCollection,
  useCopyCollectionToLibraryMutation,
} from '../../generated/graphql';
import {
  trackProviderEvent,
  ProviderAnalyticsEvent,
} from '../../lib/analytics';
import { logger } from '../../lib/logger';
import { customToast } from './ToastAlert/customToast';
import Button from './Button';

const CopyToLibraryButton: FC<{
  collection: CuratedProviderCollection;
  theme: 'secondary-white' | 'primary';
  onAdded?: () => void;
}> = ({ collection, theme, onAdded }) => {
  const [added, setAdded] = useState(false);

  const [copyCollectionToLibraryMutation, { loading }] =
    useCopyCollectionToLibraryMutation();

  return (
    <Button
      IconComponent={added ? CheckIcon : PlusIcon}
      title={added ? 'Added!' : 'Add to Library'}
      theme={theme}
      iconPosition="left"
      disabled={loading || added}
      onClick={async () => {
        try {
          await copyCollectionToLibraryMutation({
            variables: {
              input: {
                providerCollectionId: collection.providerCollection.id,
              },
            },
          });

          setAdded(true);
          trackProviderEvent(ProviderAnalyticsEvent.CollectionCopied);
          onAdded?.();
        } catch (err) {
          logger.error('Failed to copy collection to library', {
            providerCollectionId: collection.providerCollection.id,
            error: err,
          });
          customToast.error('Failed to add to library. Please try again.');
        }
      }}
    />
  );
};

export default CopyToLibraryButton;
